// extracted by mini-css-extract-plugin
export default {"zoomModal":"T1-z","image":"U1-z","button":"V1-z","isOverlayShown":"W1-z"};